import React from 'react'

import { Text, TextName } from 'sdk/text/Text'
import styles from './style.module.scss'

interface DesktopCardTextProps {
  text: string
  url?: string
}

export const DesktopCardText: React.FC<DesktopCardTextProps> = ({ text, url }) => {
  const hasLink = text.includes('here')

  return (
    <Text type={TextName.Text}>
      {text.replace(' here', '').split('\n').map((line, lineIndex) => (
        <span key={lineIndex}>
          {line}
          {lineIndex < text.replace(' here', '').split('\n').length - 1 && <br />}
        </span>
      ))}{' '}
      {hasLink && url && (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkText}
        >
          here
        </a>
      )}
    </Text>
  )
}